export const SETTING_REQUEST = "SETTING_REQUEST";
export const SETTING_SUCCESS = "SETTING_SUCCESS";

export const EMAIL_SETTING_REQUEST = "EMAIL_SETTING_REQUEST";
export const EMAIL_SETTING_SUCCESS = "EMAIL_SETTING_SUCCESS";
